import { Component, OnInit, TemplateRef, ViewEncapsulation, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { LexTranslateService } from '@app/core/services/lex-translate.service';
import { NgbModal, NgbModalRef, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'seb-modal',
  templateUrl: './modal.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./modal.component.css'],
  providers: [NgbModalConfig, NgbModal]
})
export class ModalComponent implements OnInit {

  @Input() sTitulo: String;
  @Input() smTitulo: String;
  @Input() confirmationTitle: String;
  @Input() bClose: Boolean = true;
  @Input() mClose: String = ""
  @Input() addIconX: Boolean;
  @Output() evCloseModal: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('content')
  public content: TemplateRef<any>;
  closeResult: string;
  modalRef: NgbModalRef;

  constructor(config: NgbModalConfig, private modalService: NgbModal, public lextranslate: LexTranslateService) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  public openBackDropCustomClass(content) {
    this.modalRef = this.modalService.open(content, {
      windowClass: 'myCustomModalClass',
      backdropClass: 'light-blue-backdrop',
      centered: true
    });
    this.modalRef.result.then((data) => {
      this.evCloseModal.emit();
    }, (reason) => {
    });
  }

  public open(content: any,
    windowClass: string = 'myCustomModalClass alert-sync',
    backdropClass: string = 'light-blue-backdrop',
    centered: boolean = true, backdrop: boolean = true, keyboard: boolean = false
  ) {
    this.modalService.open(content, {
      backdrop,
      centered,
      keyboard,
      windowClass,
      backdropClass
    });
  }

  public closeModal() {
    this.modalRef.close();
  }

  disabled(value: Boolean): Boolean {
    return value;
  }

  openWindowCustomClass(content) {
    this.modalService.open(content, { windowClass: 'dark-modal' });
  }

  openSm(content) {
    this.modalService.open(content, { size: 'sm' });
  }

  openLg(content) {
    this.modalService.open(content, { size: 'lg' });
  }

  openVerticallyCentered(content) {
    this.modalService.open(content, { centered: true });
  }

  openChangeStatusInBacthModal(content) {
    this.modalRef = this.modalService.open(content, { windowClass: 'modal-mass-actions' });
    this.modalRef.result.then((data) => {
      this.evCloseModal.emit();
    }, (reason) => { });
  }

  openSelectedItemsModal(content) {
    this.modalService.open(content, { windowClass: 'modal-mass-actions modal-selected-items' });
  }

  openCredentialGenerationModal(content) {
    this.modalRef = this.modalService.open(content, { windowClass: 'modal-mass-actions modal-selected-items' });
    this.modalRef.result.then((data) => {
      this.evCloseModal.emit();
    }, (reason) => { });
  }

  openInvitationModal(content) {
    this.modalRef = this.modalService.open(content, { windowClass: 'modal-mass-actions modal-selected-items' });
    this.modalRef.result.then((data) => {
      this.evCloseModal.emit();
    }, (reason) => { });
  }

  openActionResponseModal(content) {
    this.modalRef = this.modalService.open(content, { windowClass: 'modal-actions-response modal-selected-items' });
    this.modalRef.result.then((data) => {
      this.evCloseModal.emit();
    }, (reason) => { });
  }

  openViradaDeAnoModal(content) {
    this.modalRef = this.modalService.open(content, { windowClass: 'modal-actions-response modal-selected-items modal-virada-ano' });
    this.modalRef.result.then((data) => {
      this.evCloseModal.emit();
    }, (reason) => { });
  }

  async ngOnInit() {
    await this.lextranslate.loadTranslationsInFunctionOfTenant()
    this.mClose = this.lextranslate.i18n["f2929717-3d73-4a39-8280-d41f768d092b"]
  }

}
